import { FC, useEffect } from 'react'
import { useQueryClient } from 'react-query'
import { useAuth } from '../../../../../auth'
import { exameImagemHabilitado } from './exameImagemFlag'
import { ExamesImagemSecao } from './ExamesImagemSecao'

/**
 * Com a flag desligada não monta a seção: sem botão, sem GET em /exames-imagem e sem STOMP.
 * Sem sessão também não: o modal global sobrevive ao logout e mostraria a miniatura na tela de login.
 */
export const ExamesImagem: FC<{ idAtendimento: number; somenteResultados?: boolean }> = ({
  idAtendimento,
  somenteResultados,
}) => {
  const { auth, currentUser } = useAuth()
  const sessaoAtiva = !!auth?.accessToken && !!currentUser
  const queryClient = useQueryClient()

  useEffect(() => {
    if (sessaoAtiva) return
    queryClient.removeQueries('dicom-miniatura')
    queryClient.removeQueries('dicom-metadata')
  }, [sessaoAtiva, queryClient])

  return exameImagemHabilitado() && sessaoAtiva ? (
    <ExamesImagemSecao idAtendimento={idAtendimento} somenteResultados={somenteResultados} />
  ) : null
}
